// Admin API client — /admin/announcements/* (mirrors the API's announcements aggregate).

import type {
  AnnouncementCreateRequest,
  AnnouncementUpdateRequest,
  AnnouncementListResponse,
  AnnouncementDoc,
} from '@a7y/types';
import { client } from './transport';

export const announcementsApi = {
  // Announcements
  getAnnouncements: (params?: { limit?: number; offset?: number }) => {
    const searchParams = new URLSearchParams();
    if (params?.limit) searchParams.set('limit', String(params.limit));
    if (params?.offset) searchParams.set('offset', String(params.offset));
    return client.get<AnnouncementListResponse>(`/announcements?${searchParams}`);
  },
  getAnnouncement: (id: string) => client.get<AnnouncementDoc>(`/announcements/${id}`),
  createAnnouncement: (data: AnnouncementCreateRequest) =>
    client.post<{ success: boolean; data: AnnouncementDoc; broadcastResult: unknown }>(
      '/announcements',
      data
    ),
  updateAnnouncement: (id: string, data: AnnouncementUpdateRequest) =>
    client.patch<{ success: boolean; data: AnnouncementDoc; broadcastResult: unknown }>(
      `/announcements/${id}`,
      data
    ),
  deleteAnnouncement: (id: string) => client.delete<{ success: boolean }>(`/announcements/${id}`),
  broadcastAnnouncement: (id: string) =>
    client.post<{ success: boolean; broadcastResult: unknown }>(`/announcements/${id}/broadcast`),
  // A7Y-5622: the saved announcement's email, rendered by the broadcast's template.
  previewAnnouncement: (id: string) =>
    client.post<{ subject: string; html: string; text: string }>(`/announcements/${id}/preview`),
};
